import { makeStyles } from '@material-ui/styles';
import React, { useContext } from 'react';
import MessagesContext from '../../../contexts/messagesContext';
import { AddIcon } from '../../UI/Images/Icons';
import { PropTypes } from 'prop-types';
import useCheckAccess from '../../../hooks/useCheckAccess';
import { useSelector } from 'react-redux';

const styles = makeStyles({
    addNewForm: {
        width: '100%',
        background: 'transparent',
        borderRadius: '4px',
        textAlign: 'center',
        cursor: 'pointer',
        border: '1px dashed #509ffa',
        padding: '16px 0',
        fontFamily: 'inherit',
        fontSize: '13px',
        fontWeight: '500',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '1.69',
        letterSpacing: 'normal',
        color: '#509ffa',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '16px',
        '& svg': {
            width: '16px',
            height: '16px',
            margin: '0 10px'
        },
        '&:disabled': {
            opacity: 0.5,
            cursor: 'not-allowed'
        }
    }
});

const NewFormButton = ({ handleClick }) => {
    const classes = styles();
    const { messages } = useContext(MessagesContext);
    const { notEditClinical } = useCheckAccess();
    const allForms = useSelector((state) => state.dynamicForms?.allForms);

    return (
        <>
            <button
                className={classes.addNewForm}
                onClick={handleClick}
                disabled={!allForms?.length || notEditClinical}
            >
                <AddIcon color="#509ffa" />
                {messages.newForm}
            </button>
        </>
    );
};
NewFormButton.propTypes = {
    handleClick: PropTypes.func
};

export default NewFormButton;
